/* istanbul ignore file */
const getSegmentInstance = () => window?.webShellClient?.analytics || {};

export default getSegmentInstance;
